<template>
    <v-tooltip top>
        <template v-slot:activator="{on, attrs}">
            <v-btn
                :loading="loadingBtn"
                outlined
                :small="small"
                :disabled="disabled"
                :class="[customCSS, { 'PrimaryButton': isPrimary,'button-disabled': disabled }]"
                style="padding: 0px;height: 36px; pointer-events: auto;"
                @click="handleClick"
                class="buttonClass"
                v-bind="attrs"
                v-on="on"
            >
                <v-icon 
                :color="disabled ? '#aaa' : IconColor"
                    >{{ icon }}
                </v-icon>
            </v-btn>
        </template>
        <span>{{ textString }}</span>
    </v-tooltip>
</template>

<script>
export default {
name: 'IconButtonTooltip',
    props: {
        icon: {
            type: String,
            default: 'mdi-pencil'
        },
        // buttonClass: {
        //     type: String,
        //     default: 'IconButton'
        // },
        IconColor: {
            type: String,
            default: 'black'
        },
        disabled: { 
            type: Boolean,
            default: false,
        },
        small: {
          type: Boolean,
          default: false
      },
    // buttonheight: {
    //     type: String,
    //     default: '36px'
    // },
        isPrimary: {
            type: Boolean,
            default: false
        },
        // width: {
        //     type: String,
        //     default: '36px'
        // },
        loading: {
            type: Boolean,
            default: false
        },
        tooltipText: {
            type: String,
        },
        customCSS: {
            type: String
        }
    },
    computed: {
        buttonheight() {
            return this.height;
        },
        loadingBtn(){
            return this.loading;
        },
        textString(){
            return this.tooltipText;
        },
  },
    methods: {
        handleClick() {
            this.$emit('click');
        }
    }
};
</script>

<style scoped>
.buttonClass { 
    background-color: #ffffff;
    border: 1px solid #bbb; 
}
.button-disabled {
  background-color: #f9f9f9;
  border: 1px solid #eee; 
  color: #aaa;
}

.PrimaryButton {
    background: #007bff !important;
    color: #fff;
}
</style>